import React from 'react'

import Icon from 'common/components/general/Icon'

import './Home.less'

interface InfoComponentProps {
  title: string
  iconName: string
  iconClassName: string
  value: number
  className?: string
}

const InfoComponent: React.FC<InfoComponentProps> = ({ title, iconName, value, iconClassName, className }) => {
  return (
    <div className="info_component p16-24">
      <div className="flex flex__space_between">
        <div>
          <p className="color-gray-7">{title}</p>
        </div>
        <div>
          <Icon type={`far fa-${iconName}`} className={iconClassName} fontAwesome />
        </div>
      </div>

      <div>
        <h3>{value}</h3>
      </div>
    </div>
  )
}

export default InfoComponent
